import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/authentication.service';
import { NavController } from '@ionic/angular/lazy';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private readonly navCtrl: NavController
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err?.status === 401) {
          // auto logout if 401 response returned from api
          // TODO: virer ça: une URL en 401 ne veut pas dire que l'utilisateur est déconnecté
          this.authService.logout();
          this.navCtrl.navigateRoot('');
        }

        // const error = err?.error?.message || err?.error?.detail || err?.statusText;
        return throwError(err);
      })
    );
  }
}
